// @flow
import React, { Fragment } from 'react';
import { withRouter } from 'react-router';
import {
  MdDirections,
  MdAdd,
} from 'react-icons/lib/md';
import i18n from 'i18n-js';

import CardHeader from '../../CardHeader';
import CardHeaderTitleContainer from '../../CardHeaderTitleContainer';
import CardHeaderTitle from '../../CardHeaderTitle';
import CardHeaderIcon from '../../CardHeaderIcon';
import CardHeaderLeftGroup from '../../CardHeaderLeftGroup';
import CardContent from '../../CardContent';
import Popup from '../../Popup';
import OpenButton from '../../OpenButton';
import StudentSchedulingPopup from '../../StudentSchedulingPopup';
import CreateRoutePopupContent from '../../CreateRoutePopupContent';
import RoutesListCard from '../../RoutesListCard';
import { CreateButton } from '../../CommonTexts';
import CardHeaderRightGroup from '../../CardHeaderRightGroup';
// import styles from './routesView.css';


const RoutesView = () => (
  <Fragment>
    <CardHeader size="big">
      <CardHeaderLeftGroup>
        <CardHeaderIcon Icon={MdDirections} />
        <CardHeaderTitleContainer>
          <CardHeaderTitle title={i18n.t('common.routesAndStops')} />
        </CardHeaderTitleContainer>
      </CardHeaderLeftGroup>
      <CardHeaderRightGroup>
        <OpenButton title={CreateButton(i18n.t('labels.route', { count: 1 }))} Icon={MdAdd} clearMargins id="createroute" />
      </CardHeaderRightGroup>
    </CardHeader>
    <CardContent>
      <RoutesListCard />
    </CardContent>
    <Popup
      id="createroute"
      theme="main"
      transitionMs={600}
    >
      <CreateRoutePopupContent />
    </Popup>
    <Popup
      id={`routesCalendar${1}`}
      theme="main"
      transitionType="slideDown"
      transitionMs={600}
    >
      <StudentSchedulingPopup studentId={1} />
    </Popup>
  </Fragment>
);

export default withRouter(RoutesView);



// WEBPACK FOOTER //
// ./src/scripts/components/views/BackendRoutesView/index.jsx